import Layout from '@/layout'

export default [
	{
		order: 10,
		path: '/communicate-diagnosis',
		component: Layout,
		meta: {
			title: '通讯链路诊断',
			subtitle: '通讯',
			icon: 'icon-tongji',
		},
		children: [
			{
				path: '',
				name: 'communicateDiagnosis',
				meta: {
					title: '通讯链路诊断',
					keepAlive: true,
					permissions: ['trace:trace', 'trace:trace:device', 'trace:trace:communicate'],
				},
				component: () => import('@/pages/communicate-diagnosis/index.vue'),
			},
			{
				path: 'analyze-details',
				name: 'diagnosisAnalyzeDetails',
				meta: {
					title: '诊断分析详情',
					keepAlive: false,
					hidden: true,
					permissions: ['trace:trace', 'trace:trace:device', 'trace:trace:communicate'],
				},
				component: () => import('@/pages/communicate-diagnosis/AnalyzeDetails.vue'),
			},
		],
	},
]
